<template>
  <div class="table-page-wrapper">
    <div v-show="searchStatus" class="search-wrapper">
      <el-input v-model="tableParams.searchKey" placeholder="合同主体/公司简称/签订单位" clearable />
      <el-select v-model="tableParams.contractor" placeholder="请选择上下游类型" clearable style="margin-right: 15px">
        <el-option label="上游" :value="1" />
        <el-option label="下游" :value="2" />
      </el-select>
      <el-select v-model="tableParams.contractType" placeholder="请选择合作类型" clearable style="margin-right: 15px">
        <el-option label="CPM" :value="1" />
        <el-option label="CPD" :value="2" />
        <el-option label="CPS" :value="3" />
        <el-option label="CPA" :value="4" />
      </el-select>
      <base-date-picker @changeDate="changeDate" style="margin-right: 15px" />
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column @search="searchColumn" @refresh="toQuery" @change="changeColumn" :column="columns"
        style="padding-bottom: 10px">
        <el-button @click="add" type="primary" size="small">新增</el-button>
      </table-column>

      <el-table v-loading="tableLoading" :data="tableData" height="80vh" :header-cell-style="{ background: '#fafafa' }"
        highlight-current-row size="small" class="js-table" style="width: 100%">
        <el-table-column v-for="(v, i) in checkColumns" :prop="v.field" :label="v.title" :width="v.width"
          :min-width="v.minWidth" :key="i" align="center">
          <template v-slot="scope">
            <div v-if="v.field === 'contractUrl'">
              <el-button @click="downMany(scope.row.contractUrl)" type="warning" size="small">下载</el-button>
            </div>
            <div v-else-if="v.field === 'contractor'">
              <div>
                {{
                    scope.row[v.field] ? contractouList[scope.row[v.field]] : ""
                }}
              </div>
            </div>
            <div v-else-if="v.field === 'contractType'">
              <div>{{ getContractType(scope.row.contractType) }}</div>
            </div>
            <div v-else>{{ scope.row[v.field] }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="150">
          <template v-slot="scope" align="center">
            <el-button @click="update(scope.row)" type="success" size="mini">编辑</el-button>
            <el-button @click="deleData(scope.row)" type="danger" size="mini">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination @size-change="sizeChange" @current-change="currentChange" :total="pagination.total"
        :pager-count="6" :current-page="pagination.pageNum" :page-size="pagination.pageSize" :page-sizes="[10, 30, 60]"
        background layout="total,sizes,prev,pager,next" style="margin-top: 40px" />
    </div>

    <m-form @submit="toQuery" ref="form" title="合同模板" />
  </div>
</template>

<script>
import TableColumn from '@/components/TableColumn'
import BaseDatePicker from '@/components/BaseDatePicker'
import mForm from './form'
import initTableMixin from '@/mixins/initTable'
import { deletetContract } from '@/api/manage/contract/contract'

export default {
  name: 'contract',
  components: {
    TableColumn,
    BaseDatePicker,
    mForm
  },
  mixins: [initTableMixin],
  data () {
    return {
      columns: [
        { field: 'contractId', title: '唯一编号' },
        { field: 'contractor', title: '合同方' },
        { field: 'contractSubject', title: '合同主体' },
        { field: 'contractType', title: '合同类型' },
        { field: 'companyName', title: '公司简称' },
        { field: 'nit', title: '签订单位' },
        { field: 'effectiveDate', title: '有效日期' },
        { field: 'expirationDate', title: '截至日期' },
        { field: 'contractUrl', title: '文件路径' }
      ],
      contractouList: {
        1: '上游',
        2: '下游'
      },
      contractTypeList: {
        1: 'CPM',
        2: 'CPD',
        3: 'CPS',
        4: 'CPA'
      }
    }
  },
  created () { },
  mounted () {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    beforeInit () {
      this.tableParams.startTime = ''
      this.tableParams.endTime = ''
      this.tableUrl = '/contractForm/get/contract'
      return true
    },
    changeDate (date) {
      this.tableParams.startTime = date.startTime
      this.tableParams.endTime = date.endTime
    },
    add () {
      this.$refs.form.show()
    },
    update (row) {
      this.$refs.form.show(row)
    },
    getContractType (data) {
      if (data) {
        const list = data.split(',')
        let textType = ''
        list.map((item) => {
          textType = textType
            ? textType + ',' + this.contractTypeList[item]
            : this.contractTypeList[item]
        })
        return textType
      }
    },
    deleData (row) {
      this.$confirm('你确定删除该条合同模板文件吗?', '删除合同模板', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deletetContract({ deleteId: row.contractId }).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.toQuery()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    downMany (list) {
      function downloadFile (url) {
        const link = document.createElement('a')
        link.href = url
        link.target = '_blank' // 在新窗口中打开，如果需要
        link.style.display = 'none'
        // 设置链接下载属性
        link.download = 'file.pdf' // 设置下载文件的名称
        // 将链接添加到文档中
        document.body.appendChild(link)
        // 模拟点击链接触发下载
        link.click()
        // 移除链接
        document.body.removeChild(link)
      }
      const ua = navigator.userAgent.toLocaleLowerCase()
      if (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {
        list.map((url) => {
          window.location.href = url
        })
      } else {
        if (list) {
          list.map((url) => {
            downloadFile(url)
          })
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  &>* {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  &>.el-select,
  &>.el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-table::before {
  height: 0;
}

.el-pagination {
  text-align: right;
}
</style>
